import React from "react";

export default function TitleText(props) {
  return <h1 className="sp-block sp-h1">{props.text}</h1>;
}
